// @ts-nocheck
import axios from "@/helpers/interceptors";
import {
  generateUniqueHash, getEntityId,
  getRegistrationToken,
  getUserId,
  logout,
  setAccessToken,
  setAuthRefreshToken,
  setAuthRefreshTokenExpirationDate,
  setAuthUserId,
  setEntityId,
	getAccessToken
} from "@/helpers/utils";
import { v4 as uuidv4 } from "uuid";
import {B2bPortalRight} from "@/enums/B2bPortalRight";

export default {
  state: {
    country_list: null,
    all_country_list: null,
    country_doc_list: null,
    registrationBackendErrors: {},
    role_list: [],
    company_list: null,
    company_list_by_shareholder: null,
    current_company: null,
    current_user: null,
    tariff: null,
    tariff_proposed: null,
		has_expired_mode: false,
    permissions: (() => {
      try {
        const stored = sessionStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : null;
      } catch (error) {
        console.warn('Failed to parse stored permissions:', error);
        return null;
      }
    })(),
  },
  mutations: {
    SET_ERRORS(state, payload) {
      state.registrationBackendErrors = { ...payload, ...state.registrationBackendErrors };
    },
    CLEAR_ERROR_BY_NAME(state, payload) {
      delete state.registrationBackendErrors[payload];
    },
    SET_COUNTRY_LIST(state, payload) {
      state.country_list = payload;
    },
    SET_ALL_COUNTRY_LIST(state, payload) {
      state.all_country_list = payload;
    },
    SET_COUNTRY_DOC_LIST(state, payload) {
      state.country_doc_list = payload;
    },
    SET_ROLE_LIST(state, payload) {
      state.role_list = payload;
    },
    SET_COMPANY_LIST(state, payload) {
      state.company_list = payload;
    },
    SET_COMPANY_LIST_BY_SHAREHOLDER(state, payload) {
      state.company_list_by_shareholder = payload;
    },

    SET_CURRENT_COMPANY(state, payload) {
      state.current_company = payload;
    },
    SET_CURRENT_USER(state, payload) {
      state.current_user = payload;
    },
    SET_TARIFF(state, payload) {
      state.tariff = payload;
    },
    SET_TARIFF_PROPOSED(state, payload) {
      state.tariff_proposed = payload;
    },
    SET_HAS_EXPIRED_MODE(state, boolean) {
      state.has_expired_mode = boolean;
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
      // Store permissions in sessionStorage for persistence across page reloads
      if (permissions) {
        sessionStorage.setItem('user_permissions', JSON.stringify(permissions));
      } else {
        sessionStorage.removeItem('user_permissions');
      }
    },
    CLEAR_PERMISSIONS(state) {
      state.permissions = null;
      sessionStorage.removeItem('user_permissions');
    },
  },
  actions: {

    /**
     * @name initOtp
     * @description check mobile number
     */
    async initOtp(_, body) {
      const res = await axios.post("/api/auth/init-otp", body);
      await logout();
      return res;
    },

    /**
     * @name initOtpResetPassword
     * @description check mobile number for reset password
     */
    async initOtpResetPassword(_, body) {
      return await axios.post("/api/auth/step1/init-otp-reset-password", body);
    },

    /**
     * @name verifyOtp
     * @description send otp code
     */
    async verifyOtp(_, body) {
      return await axios.post("/api/auth/verify-otp", body);
    },

    /**
     * @name verifyOtpResetPassword
     * @description send otp code
     */
    async completeOtpResetPassword(_, body) {
      return await axios.post("/api/auth/step2/complete-otp-reset-password", body);
    },

    /**
     * @name completeResetPassword
     * @description send otp code
     */
    async completeResetPassword(_, body) {
      return await axios.post("/api/auth/step3/complete-reset-password", body);
    },

    /**
     * @name getCountryList
     * @description get list of countries
     */
    async getCountryList({ commit }) {
      const { data, status } = await axios.get(`/api/registration/init/countries?${generateUniqueHash()}`);
      if (status === 200 && data) {
        const sort_country = data.sort((a, b) => a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase()));
        commit("SET_COUNTRY_LIST", sort_country);
      }
    },
    async getAllCountryList({ commit }) {
      const { data, status } = await axios.get(`/api/registration/init/all-countries?${generateUniqueHash()}`);
      if (status === 200 && data) {
        const sort_country = data.sort((a, b) => a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase()));
        commit("SET_ALL_COUNTRY_LIST", sort_country);
      }
    },
    // eslint-disable-next-line consistent-return
    async getCountryDocList({ commit }, code) {
      const { data } = await axios.get(`/api/registration/init/country-documents/${code}?${generateUniqueHash()}`);
      if (data) {
        commit("SET_COUNTRY_DOC_LIST", data);
        return data;
      }
    },

    async getRoleList({ commit }) {
			//Check if token not Exist don't call axios
			const accessToken = await getAccessToken();
			if(!accessToken) return
			//end Check if token not Exist don't call axios

      const { data } = await axios.get(`/api/registration/init/roles?${generateUniqueHash()}`);
      commit("SET_ROLE_LIST", data);
    },

    async getCompanyList({ commit }) {
      const { data } = await axios.get("/api/companies/");
      commit("SET_COMPANY_LIST", data);
      return data;
    },


    // eslint-disable-next-line consistent-return
    async getCompaniesByShareHolder({ commit }) {
      const { status, data } = await axios.get("/api/registration/shareholder-company/getByShareHolder");
      if (status === 200) {
        commit("SET_COMPANY_LIST_BY_SHAREHOLDER", data);
        return data;
      }
    },

    // eslint-disable-next-line consistent-return
    async createNewEntity({ dispatch }) {
      const { status, data } = await axios.post("api/registration/create-entity");
      if (status === 200 && data.entityId) {
        await setEntityId(data.entityId);
        await dispatch("loginCurrentCompany", { companyId: data.entityId });
        await dispatch("getCompanyById", data.entityId);
        return { status };
      }
    },
     // eslint-disable-next-line consistent-return
     async createNewMerchantLegalEntity() {
      const { status, data } = await axios.post("api/registration/create-entity");
      if (status === 200 && data.entityId) {
        const entityId = data.entityId;
        return { status, entityId };
      }
      return { status, entityId: null };
    },
    // eslint-disable-next-line consistent-return
    async joinEntity(_, entityId) {
      const { status } = await axios.post("api/registration/join-entity", { entityId });
      if (status === 200) {
        await setEntityId(entityId);
        return { status };
      }
    },

    async getCompanyById({ commit }, companyId) {
      if(!companyId) return []
      const { data } = await axios.get(`/api/companies/${companyId}`);
      commit("SET_CURRENT_COMPANY", data);
      console.log(data, "data");
      const user = data?.foundersState?.shareholderPersonList.find(({ shareholderPersonId }) => shareholderPersonId === getUserId());
      commit("SET_CURRENT_USER", user);

			//Add in Widget params Company name for Operator
			if(data && data?.name) {
				const textStatic = `Current company of User is: ${data.name}`
				try {
					kw_event('kwsetparamsfromsite', { params_from_site: { company_name: textStatic }})
				} catch (e) {
					// console.log(e, 'error on kwsetparamsfromsite event Widget')
				}
			}
			//end Add in params of Widget Company name for Operators

      return data;
    },

    // send otp code

    // registration step 1 (personal info)
    async createPersonalInfoShareholder(_, body) {
      return await axios.post("/api/registration/step1/personal-info-shareholders", body, {
        headers: {
          Authorization: `Bearer ${getRegistrationToken()}`,
          isUniqueToken: true
        }
      });
    },

    async getPersonalInfoShareholder() {
      return await axios.get("/api/registration/personal-info-shareholders", {
        headers: {
          Authorization: `Bearer ${getRegistrationToken()}`,
          isUniqueToken: true
        }
      });
    },

    async getTermsUrl() {
      const { data } = await axios.post("/api/registration/terms");
      return data;
    },

    // registration step 2 (company info)
    async createCompanyInfo(_, body) {
      return await axios.post("/api/registration/step2/company-info", body);
    },

    async downloadCompanyFiles(_, body) {
      return await axios.post("/api/registration/step2/company-field", body);
    },

    // registration step 3 (company structure)
    async createCompanyStructure(_, body) {
      return await axios.post("/api/registration/step3/company-structure", body);
    },

    // get country list
    async getCountry() {
      return await axios.get(`/api/registration/init/countries?${generateUniqueHash()}`);
    },

    // login
    async login({ commit }, data) {
      const res = await axios.post("/api/auth/login", data);
      await logout();
      await setAuthUserId(res.data.userId);
      await setAccessToken(res.data.accessToken);
      await setAuthRefreshToken(res.data.refreshToken, res.data?.refreshTokenExpiredTo);
      await setAuthRefreshTokenExpirationDate(res.data?.refreshTokenExpiredTo);
      await commit("SET_PERMISSIONS", res.data.permissions);
      return res;
    },

    // login current company
    async loginCurrentCompany({ commit }, data) {
      const res = await axios.post("/api/auth/current-company", data);
      await setEntityId(data.companyId);
      await setAccessToken(res.data.accessToken);
      await commit("SET_PERMISSIONS", res.data.permissions);
      return res;
    },

    // upload file
    async uploadFile(_, body) {
      const formData = new FormData();
      
      // Add comment if provided
      if (body.comment) {
        formData.append('Comment', body.comment);
      }
      
      // Add requestId
      if (body.requestId) {
        formData.append('RequestId', body.requestId);
      }
      
      // Add files - ASP.NET Core expects files to be appended individually
      if (body.files && Array.isArray(body.files)) {
        body.files.forEach((file) => {
          // Handle different file object structures
          const fileToAppend = file instanceof File ? file : (file.file || file);
          if (fileToAppend instanceof File) {
            formData.append('Files', fileToAppend);
          }
        });
      }
      
      return await axios.post("/api/registration/user-document", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },

    async getInvoice() {
      return await axios.get("/api/payments/invoice", { responseType: "arraybuffer" });
    },
    async paidInvoice(_, entityId) {
      return await axios.post(`/api/registration/invoice-payed/${entityId}`);
    },
    async getCompanyTariff({ commit }) {
      const res = await axios.get("/api/client/tariff");
      if (res.status === 200) {
        commit("SET_TARIFF", res.data);
      }
    },
    async getCompanyTariffProposed({ commit, getters }) {
      if(!getters.hasRight(B2bPortalRight.TariffView)) {
        return;
      }
      const res = await axios.get("/api/client/tariff-proposed");
      if (res.status === 200) {
        commit("SET_TARIFF_PROPOSED", res.data);
      }
    },
    async getSumSubRegistrationLink(_, legalEntityId, applicantId) {
      return await axios.get(`/api/sumsub/kyb/${legalEntityId}/${applicantId}`);
    },
    async logout({ commit }) {
      await logout();
      commit('CLEAR_PERMISSIONS');
    },
  },
  getters: {
    registrationBackendErrors: (state) => state.registrationBackendErrors,
    countryList: (state) => state.country_list || [],
    allCountryList: (state) => state.all_country_list || [],
    roleList: (state) => state.role_list,
    listDocs: (state) => state.country_doc_list,
    companyList: (state) => state.company_list,
    companyListByShareholder: (state) => state.company_list_by_shareholder,
    currentCompany: (state) => state.current_company,
    currentUser: (state) => state.current_user,
    tariff: (state) => state.tariff,
    tariffProposed: (state) => state.tariff_proposed,
		has_expired_mode: (state) => state.has_expired_mode,
    permissions: (state) => state.permissions,
    hasRight: (state) => (right) => {
      const rights = state.permissions?.rights;
      if (!Array.isArray(rights)) return false;
      return rights.includes(right);
    },
  }
};
